import { createMuiTheme } from '@material-ui/core';
import theme from '../../theme';

export const datePickerTheme = createMuiTheme({
  ...theme,
});
